
export const SET_CARD = 'SET_CARD'